module.exports = __webpack_public_path__ + "img/services.9e54f6e9.jpg";